import InAppMessage from "./in-app-message.js";
export default class HtmlMessage extends InAppMessage {
  constructor(l, u, n, e, r, s, t, i, o, a, c) {
    super(
      l,
      null,
      null,
      u,
      n,
      null,
      null,
      null,
      (e = e || InAppMessage.DismissType.MANUAL),
      r,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      s,
      t,
      null,
      null,
      null,
      i,
      void 0,
      void 0,
      void 0,
      o,
      a
    ),
      (this.messageFields = c);
  }
  ll() {
    return !1;
  }
  k(l) {
    if (this.Ce === InAppMessage.es.ul) {
      if (this.nl) return !1;
      this.nl = !0;
    }
    return this.lt.St(l), !0;
  }
}
HtmlMessage.es = InAppMessage.es.ul;
